// 평가계획서에서 평가가 여러 개 나왔을 때 '합쳐서 쓰기'(merge)와 '하나씩 쓰기'(single)를 나눈다.
// 평가가 많거나 과목이 섞이면 학교 전체 계획서일 가능성이 높아, 전부 합치지 않고 하나를 고르게 한다.
export const SINGLE_DEFAULT_MIN_UNITS = 6;

export const countPlanSubjects = (items = []) => new Set(
  items.map((item) => String(item?.subject || '').trim()).filter(Boolean)
).size;

export const resolveInitialPlanSelection = (items = []) => {
  const preferSingle = items.length >= SINGLE_DEFAULT_MIN_UNITS || countPlanSubjects(items) > 1;
  return preferSingle
    ? { planMode: 'single', selectedItems: [] }
    : { planMode: 'merge', selectedItems: items };
};

export const nextPlanSelection = (planMode, currentItems = [], item) => {
  if (planMode === 'single') return [item];
  const isSelected = currentItems.some((selected) => selected.id === item.id);
  return isSelected
    ? currentItems.filter((selected) => selected.id !== item.id)
    : [...currentItems, item];
};

// 칩 이름: "과목 + 꼬리말(활동명·성취기준 코드)". 번호는 이름이 실제로 겹치는 칩끼리만 1부터 붙인다.
export const buildPlanItemNames = (items = [], suffixOf = () => '') => {
  const parts = items.map((item) => ({
    subject: String(item?.subject || '').trim() || '과목',
    suffix: suffixOf(item) || '',
  }));
  const totals = {};
  parts.forEach(({ subject, suffix }) => {
    const key = `${subject}${suffix}`;
    totals[key] = (totals[key] || 0) + 1;
  });
  const seen = {};
  return parts.map(({ subject, suffix }) => {
    const key = `${subject}${suffix}`;
    if (totals[key] < 2) return key;
    seen[key] = (seen[key] || 0) + 1;
    return `${subject} ${seen[key]}${suffix}`;
  });
};

export const activityNameSuffix = (item) => {
  const name = String(item?.activity_name || '').trim();
  if (!name) return '';
  return ` - ${name.length > 15 ? `${name.substring(0, 15)}...` : name}`;
};

export const achievementCodeSuffix = (item) => {
  const match = String(item?.achievement_standard || '').match(/\[[\d\w가-힣]+-\d+\]/);
  return match ? ` ${match[0]}` : '';
};

// 일괄 생성: 분석 결과의 평가 목록. 평가가 하나뿐이면 빈 배열.
export const listPlanItems = (analyzedData = {}) => {
  const items = analyzedData?.parsed_activities || analyzedData?.parsed_subjects || [];
  return Array.isArray(items) && items.length > 1 ? items : [];
};

export const planItemSuffix = (item) => activityNameSuffix(item) || achievementCodeSuffix(item);

// 일괄 생성은 고른 평가가 반 전체의 참고자료가 되므로, 평가가 2개 이상이면 항상 먼저 고르게 한다
// ('모두 합쳐서 쓰기'도 그중 하나). 단일 생성처럼 합친 뒤 칩으로 빼는 단계가 없기 때문이다.
export const shouldPickBatchPlanItem = (items = []) => items.length > 1;

export const buildPlanSelectionMeta = (planMode, detectedCount) => (
  detectedCount > 1
    ? { eval_plan_mode: planMode === 'single' ? 'single' : 'merge', eval_unit_detected_count: detectedCount }
    : {}
);
